import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { Divider } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import ListDetail from "./RiskRegisterRowExpandDetail";
import ListDetailForm from "./RiskRegisterDetail";
import SimpleSelect from '../SharedComponents/riskRegisterdropdownselection'
import { extractData } from '../../util/TableUtil'
import moment from 'moment';
import setting from "../../config/setting";
import { styles } from '../CSS/Styles';
import Collapse from "@material-ui/core/Collapse";


function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

class EnhancedTableHead extends React.Component {

    constructor(props) {
        super(props);
        this.getTableHeader = this.getTableHeader.bind(this);
        this.state = {
            typename:null,
            rows: []
        }
    }
    componentWillMount() {
        let pathtypename = this.props.type;
        // console.log(this.props);
        // console.log("header type name" + this.props.type);
        this.setState({typename: pathtypename});
    }
    componentDidMount() {
        this.getTableHeader();
    }
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };
    getTableHeader = () => {
        let header = ['No', 'Risk', 'Lead Risk Owners', 'Date Modified']
        this.setState({ rows: header })
    }

    render() {
        const { onSelectAllClick, order, orderBy, numSelected, rowCount } = this.props;

        return (
            <TableHead>
                <TableRow style={{whiteSpace:'nowrap'}}>
                    {this.state.rows.map(row => {
                        return (
                            <TableCell>
                                {row.replace(/_/g,' ')}
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

class VendorAlertTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            updatedetailriskname:"",
            typename: null,
            open: true,
            anchor: 'right',
            order: 'asc',
            orderBy: 'No',
            details: true,
            list: 5,
            selected: [],
            data: [
            ],
            fields: [],
            page: 0,
            rowsPerPage: 10,
            filtered: [],
            filter: 1,
            RowExpandID: null
        };
        this.getAlerts = this.getAlerts.bind(this);


    }
    componentWillMount() {
        let pathtypename = this.props.type
        this.setState({typename: pathtypename})
    }
    componentDidMount() {
        this.getAlerts();
    }
    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) {
            this.getAlerts();
            let pathtypename = this.props.type;
            this.setState({ typename: pathtypename })
        }
    }
    getAlerts() {
        let header = ['No', 'Risk', 'Lead Risk Owners', 'Date Modified']
        let databaseheader = ['risk_name', 'risk_name', 'owners', 'update_time']
        let filtered = extractData(this.props.data, header, databaseheader)
        this.setState({filtered: filtered, fields: header})
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState(state => ({ selected: state.data.map(n => n.id) }));
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, id, alert) => {
        // console.log("clicked ID is "+id);
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        this.setState({ selectedAlert: alert })
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({ selected: newSelected })
    };
    handleDetailClick(event, alert) {
        this.setState({selectedAlert: alert})
    }
    handleChangePage = (event, page) => {
        this.setState({ page })
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value })
    };
    handleAction = event => {
        this.setState({ details: this.state.details ? false : true })
        this.setState({ list: this.state.list == 6 ? 12 : 6 })
    };
    isSelected = id => this.state.selected.indexOf(id) !== -1;

    handleUpdateDetail = (riskname, index) => {
        // console.log("clicked row with id " + id);
        this.setState({ updatedetailriskname: riskname, RowExpandID: index})
    };

    _onChangeSearch = (e) =>{
        //console.log(e.target.value);
        if (e.target.value) {
            console.log(e.target.value)
            console.log(this.state.data)
            var filtered = this.state.data.filter(function(itm) {
                return itm.description.toLowerCase().includes(e.target.value.toLowerCase())
            });
        } else {
            var filtered = this.state.data
        }
        
        //console.log(filtered);
        this.setState({filtered: filtered})
    };

    handleSlectionChange = (value)=>{
        this.setState({filter:value})
    }

    render() {

        const { classes } = this.props;
        const { data, order, orderBy, selected, rowsPerPage, page, list , filtered}  = this.state;
        // console.log("passing update row with id " + this.state.updatedetailID);
        // <Grid item md={7} className={classes.contentWrapper}>
        let riskdata = this.props.data.find(item => item.risk_name == this.state.updatedetailriskname)
        const formdetail = (
            <Grid item md={7} className={classes.contentWrapper}>
                {this.state.updatedetailriskname == "" ? null :
                    <ListDetailForm
                        employee={this.props.employee}
                        username={this.props.username}
                        risk={riskdata}
                        riskname={this.state.updatedetailriskname}
                    />
                }
                <div style={{ height: "5px" }}/>
            </Grid>
        )

        const detailsView = (
            <div>
                <ListDetail update={()=>{this.props.update()}} username={this.props.username} risk={this.props.data} riskname={this.state.updatedetailriskname}/>
            </div>
        )
        return (
            <Paper className={classes.root} style={{height:'100%'}}>
                <Grid container padding style={{height:'100%'}}>
                    <Grid item md={list} className={classes.grid}  style={{height:'100%'}}>
                        <Typography color="inherit" variant="h7" style={{padding:'15px 0px 10px 20px', lineHeight:'70px', textAlign:'left'}}>
                            ABC Group - Risk Registers
                            <SimpleSelect handleSlectionChange={this.handleSlectionChange}/>
                        </Typography>

                        <Card className={classes.tableWrapper} style={{display:'inline-block', width:'100%', height:'82vh'}}>                            
                            <Table className={classes.table} aria-labelledby="tableTitle" padding='dense'>
                                <EnhancedTableHead
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onSelectAllClick={this.handleSelectAllClick}
                                    onRequestSort={this.handleRequestSort}
                                    rowCount={data.length}
                                    type={this.state.typename}
                                />
                                <TableBody>
                                    {filtered
                                        .sort(getSorting(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((n,index) => {
                                            const isSelected = this.isSelected(n.id);
                                            let i = 0;
                                            //if (this.state.filter == 1 && n.Tier !='Tier1' || this.state.filter == 2 && n.Tier =='Tier1' ) {
                                            //    return null
                                            //}
                                            return ([
                                                <TableRow
                                                    hover
                                                    aria-checked={isSelected}
                                                    tabIndex={-1}
                                                    key={n.id}
                                                    selected={isSelected}
                                                    onClick={()=>this.handleUpdateDetail(n.No + " " + n.Risk, index)}
                                                >
                                                    {
                                                        this.state.fields.map(f => {
                                                            return (
                                                                <TableCell onClick={event => this.handleDetailClick(event, n)}>
                                                                    <Typography className={ f == 'Risk' ? classes.table_cell_nowrap : classes.table_cell}>
                                                                        {f == "created_date" ? moment(n[f]).format(setting.date_format) : n[f]}
                                                                    </Typography>
                                                                </TableCell>);
                                                        })
                                                    }
                                                </TableRow>,
                                                <TableRow style={{ height: "0px" }}>
                                                    <TableCell style={{ paddingBottom: 0, paddingTop: 0, paddingRight: 0 }} colSpan={4}>
                                                        <Collapse
                                                            in={this.state.RowExpandID == index}
                                                            timeout="auto"
                                                            unmountOnExit
                                                        >
                                                            {this.state.details ? detailsView : null}
                                                        </Collapse>
                                                    </TableCell>
                                                </TableRow>
                                            ])
                                        })}
                                </TableBody>
                            </Table>
                        </Card>                       
                    </Grid>
                    {this.state.details ? formdetail : null}
                </Grid>
                <Divider />
            </Paper>
        );
    }
}

VendorAlertTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(VendorAlertTable);


// WEBPACK FOOTER //
// ./src/components/Risks/RiskRegisterSummary.js